<!-- 所有权限 -->
<template>
  <div class="right" style="">
    <div class="right-title" style="display: flex;">
      <div style="display:inlink-block;" class="right-title-item"
        :class="show_permiss == index ? 'right-title-item-checked' : ''" @click="showPermiss(index)"
        v-for="(item, index) in treeData" :key="index">
        {{ item.label }}
      </div>
      <div v-if="allp" class="right-title-item" style="color:#6fc743" @click="allChecked">
        全选 / 取消全选
      </div>
    </div>
    <div style="max-width: 700px;" :style="{ maxHeight: height + 'px' }">
      <el-scrollbar wrapStyle="overflow-x:hidden;" :style="{ height: height + 'px' }"><!-- style="height: 580px;" -->
        <div v-for="(item, index) in treeData" :key="index">
          <div v-show="show_permiss == index" v-for="(citem, cindex) in item.childList" :key="cindex"
            class="el-form-item-fa">
            <!-- " -->
            <div class="p-form" @click.stop="">
              <div class="p-form-item">
                <div class="label" @click="checkedAll(citem)">
                  {{ citem.label }}
                </div>
                <div>
                  <el-checkbox-group @click.stop="" v-model="checked_list" @change="checkedChange">
                    <el-checkbox :disabled="disabled" size="large" v-for="(ccitem, ccindex) in citem.childList"
                      :key="ccindex" :label="ccitem.label" style="">
                      <div class="checkbox-item">
                        <div style="width: 150px;">{{ ccitem.label }}</div>
                        <div class="ellipsis" style="width: calc(100% - 150px);font-size: 12px;color: #909399;">
                          {{ ccitem.remark }}</div>
                      </div>
                    </el-checkbox>

                  </el-checkbox-group>
                </div>

              </div>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
import { deleteTabRepeat } from "@/js/public.js";
export default {
  name: "all-permission",
  props: {
    treeData: [],
    disabled: {
      default: false,
      type: Boolean
    },
    height: String,
    allp: {
      default: false,
      type: Boolean
    },
    treeData6: []
  },
  data() {
    return {
      show_permiss: 0,
      checked_list: [], //选中的列表
      clicked_all_list: [] //点击过全选的部分
    };
  },
  methods: {
    /**
     * 点击部分全选
     * @param res
     */
    checkedAll(res, index) {
      let list = res.childList.map(item => {
        return item.label;
      });
      let slist = new Set([]);//保存 list里有的，check_list 也有的
      if (list.length > 0 && this.checked_list.length > 0) {
        for (let i = 0; i < list.length; i++) { //如果选中列表不为空
          if (this.checked_list.indexOf(list[i]) > -1) {
            slist.add(list[i]);
          }
        }
        try {
          if (slist.size === 0) {
            this.changeChecked(list.concat(this.checked_list));
            return;
          }
          if (slist.size > 0 && slist.size < list.length) { //大于0 小于list.length 表示没全选中
            slist.union(list).union(this.checked_list);
            this.changeChecked(slist);
            return;
          } else if (slist.size === list.length) { //等于0 表示 已经选中，需要全部取消
            const a = deleteTabRepeat(list, this.checked_list);
            this.changeChecked(a);
            return;
          }
        } catch (e) {
          const a = deleteTabRepeat(new Set(list), this.checked_list);
          this.changeChecked(a);
        }
      } if (list.length > 0 && this.checked_list.length === 0) { //如果选中列表为空
        this.changeChecked(list);
      }
    },
    showPermiss(key) {
      this.show_permiss = key;
      this.$emit("merchantSet", key);
    },
    /**
     * 权限全选
     */
    allChecked() {
      if (this.checked_list.length === this.treeData6.length) {
        this.changeChecked([]);
      } else {
        var list = this.treeData6.map(item => {
          return item.label;
        });
        this.changeChecked(list);
      }
    },
    changeChecked(list) {
      this.checked_list = [];
      this.checked_list = Array.from(new Set(list));
      this.checkedChange(this.checked_list);
    },
    checkedChange(e) {
      this.$emit("checkedChange", e);
    }
  }
};
</script>

<style scoped lang="less">
.p-form {
  width: auto;

  .p-form-item {
    display: flex;
    align-items: center;
    padding: 10px;

    .label {
      width: 100px;
      min-width: 100px;
      height: 100%;
      min-height: 50px;
      display: flex;
      align-items: center;
      justify-content: left;
      user-select: none;
    }

    .value {}

    .el-checkbox {
      width: 94%;
      margin-left: 0 !important;
      height: 35px;
      display: flex;
      align-items: center;
    }
  }
}

.right {
  width: 100%;
  max-width: 900px;
  margin-bottom: 10px;

  .right-title {
    // width: 100%;
    // height: 40px;
    background-color: #fff;
    display: flex;
    /* justify-content: left;
    align-items: center; */
    font-size: 16px;
    font-weight: 700;
    overflow-x: auto;

    .right-title-item {
      flex-shrink: 0;
      width: auto;
      min-width: 60px;
      height: 30px;
      padding: 5px;
      text-align: center;
      cursor: pointer;
      user-select: none;
      font-size: 14px;
    }

    .right-title-item-checked {
      background-color: #6fc743;
      color: #fff;
    }
  }
}

.el-form-item-fa {
  font-size: 16px !important;
  // border: 1px solid #ccc;
  padding: 10px 0;
  border-radius: 20px;
  margin: 10px;
  background-color: rgba(0, 0, 0, 0.02);
  cursor: pointer;
  // background-color: pink;
  // box-shadow: 0 0 10px #3a61c2;
  /*  /deep/.el-form-item__label{
    // color:#fff;
  } */
}

// rgba(50, 16, 109, 0.8);
.el-checkbox.is-bordered {
  padding: 9px 20px 9px 10px;
  border-radius: 4px;
  // border: 1px solid #fff;
  box-sizing: border-box;
  line-height: normal;
  height: 40px;
}

/deep/.el-form-item__label {
  cursor: pointer !important;
}

.checkbox-item {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

/* label {
  // color: #fff;
} */
</style>
